<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Data Deletion Request – Ukata / Epic Ninja / Stavira VN</title>
  </head>
  <body>
    <h1>Delete Your App Account and Data</h1>

    <p>
      This page is for users of any app published by the developers
      <strong>Epic Ninja</strong> and <strong>Stavira VN</strong> on Google
      Play.
    </p>
    <p>
      If you are a user of apps such as
      <strong>Ukata (the web apps under the domain ukata.io)</strong> or any
      other app listed under our developer accounts below, and wish to have your
      personal data or account deleted, please follow the steps below.
    </p>

    <ul>
      <li>
        <a
          href="https://play.google.com/store/apps/developer?id=Epic+Ninja"
          target="_blank"
          >Epic Ninja Developer Page</a
        >
      </li>
      <li>
        <a
          href="https://play.google.com/store/apps/developer?id=Stavira+VN"
          target="_blank"
          >Stavira VN Developer Page</a
        >
      </li>
    </ul>

    <h2>How to Request Data Deletion</h2>

    <p>
      Please send an email to
      <a href="mailto:dat.tm24@gmail.com">dat.tm24&#64;gmail.com</a> from the
      email address associated with your account in the app.
    </p>

    <p><strong>Email subject:</strong> Data Deletion Request</p>

    <p><strong>In the email body, include the following details:</strong></p>
    <ul>
      <li>Your full name</li>
      <li>
        The name of the app you’re using (e.g., Ukata, Epic Ninja's apps...)
      </li>
      <li>The email address associated with your account in the app</li>
    </ul>

    <h2>Verification Process</h2>
    <p>
      To protect your privacy and prevent unauthorized deletion, we will verify
      your identity based on the information you provide. If necessary, we may
      follow up with you via email for additional verification.
    </p>

    <h2>Deletion Timeline</h2>
    <p>
      Once verified, we will delete your data within
      <strong>90 days</strong> and notify you when the process is complete.
    </p>

    <h2>Data Retention Policy</h2>
    <p>
      We retain data only as long as needed for the purposes outlined in our
      privacy policy or as required by law. Once deleted, your data will be
      permanently removed from our systems and backups (unless legal retention
      is required).
    </p>

    <h2>Your Data Rights</h2>
    <p>
      You have the right to request access, correction, deletion, or restriction
      of your data. For more information, please refer to our full
      <a href="/public/privacy">Privacy Policy</a>.
    </p>

    <h2>Contact Us</h2>
    <p>
      If you have any questions or concerns about this process, feel free to
      contact us at
      <a href="mailto:dat.tm24@gmail.com">dat.tm24&#64;gmail.com</a>.
    </p>
  </body>
</html>
